import { QueryClient } from "@tanstack/react-query";
import { getLocked } from "./lockStatus";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      queryFn: async ({ queryKey }) => {
        // Don't fire any request while the session is locked — every
        // active query (notification poll, tasks poll, route data
        // already on screen) would just round-trip a 401 LOCKED and
        // spam the console. The post-unlock invalidateQueries() in
        // SessionLockController re-runs us with the unlocked session.
        if (getLocked()) {
          throw new Error("LOCKED");
        }
        const path = Array.isArray(queryKey) ? String(queryKey[0]) : String(queryKey);
        const r = await fetch(path, { credentials: "include" });
        if (r.status === 401) {
          const body = (await r.json().catch(() => ({}))) as { code?: string };
          if (body.code === "LOCKED") {
            window.dispatchEvent(new CustomEvent("cerebellum:locked"));
          } else {
            // Plain 401 from any endpoint: server-side session is gone.
            // Surface that so the cached /api/me clears and AuthGuard
            // routes the user to /login instead of leaving them on a
            // page where every subsequent request will fail.
            window.dispatchEvent(new CustomEvent("cerebellum:auth-expired"));
          }
        }
        if (!r.ok) throw new Error(`Request failed: ${r.status}`);
        return r.json();
      },
    },
  },
});
